__turbopack_context__.v({
  "link": "QvDOfq_link",
  "shimmer": "QvDOfq_shimmer",
  "text-bar-sweep": "QvDOfq_text-bar-sweep",
});
